//filter opener start

document.querySelector('#blog-heading__filter-btn').onclick = (e) => {
    var shopFilterBox = document.querySelector('#blog-list');
    e.preventDefault();
    e.target.classList.toggle('active');
    shopFilterBox.classList.toggle('section-blog-list-filter');
}

//filter opener end